<template>
  <ElDialog
    :visible.sync="visible"
    title="选择角色"
    top="10vh"
    width="910px"
    custom-class="role-picker-dialog"
    append-to-body
  >
    <div class="role-picker">
      <div class="filter-bar">
        <div class="footer">
          <div class="tab-box">
            <div
              v-for="item in enemyArr"
              :key="item.val"
              :class="['tab-item', 'level', activeStar === item.val ? 'active' : '']"
              @click="handleItem(item)"
            >
              {{ item.label }}
            </div>
          </div>
          <div class="tab-box">
            <div
              v-for="item in propertyArr"
              :key="item.val"
              :class="['tab-item', 'property', activeProperty === item.val ? 'active' : '']"
              @click="handlePropertyItem(item)"
            >
              <img :src="item.url" alt="" />
            </div>
          </div>
        </div>
        <div class="search">
          <input placeholder="请输入角色名称" v-model="keyword" type="text" />
        </div>
      </div>
      <div class="content">
        <div class="role-box">
          <div
            v-for="item in filterRoleList"
            :key="item.id"
            :class="['role-item', getItemBg(item)]"
            @click="handlePickRole(item)"
          >
            <div class="bottom-info">
              {{ item.name }}
            </div>
            <img v-if="item.type === 'role'" :src="item.icon_1" />
            <img v-else-if="item.type === 'pet'" :src="item.icon" />
          </div>
        </div>
      </div>
    </div>
  </ElDialog>
</template>
<script>
import { apiGetBattleRoleList } from "@/api/wiki-zsca";

export default {
  name: "RolePicker",
  props: { value: { type: Boolean, default: false }, roleList: { type: Array, default: () => [] } },
  data() {
    return {
      keyword: "",
      activeProperty: "",
      activeType: 1,
      activeStar: "",
      ourTeam: [],
      enemyArr: [
        { val: "5星", label: "5 ★" },
        { val: "4星", label: "4 ★" },
        { val: "3星", label: "3 ★" },
        { val: "pet", label: "召唤物" }
      ],
      propertyArr: [
        { val: "火", url: require("@/assets/zs_imgs/battle/huo.png"), label: "火" },
        { val: "水", url: require("@/assets/zs_imgs/battle/shui.png"), label: "水" },
        { val: "风", url: require("@/assets/zs_imgs/battle/feng.png"), label: "风" },
        { val: "光", url: require("@/assets/zs_imgs/battle/guang.png"), label: "光" },
        { val: "暗", url: require("@/assets/zs_imgs/battle/an.png"), label: "暗" }
      ]
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(bool) {
        this.$emit("input", bool);
      }
    },
    filterRoleList() {
      let result = JSON.parse(JSON.stringify(this.roleList));
      if (this.ourTeam && this.ourTeam.length) {
        // 先过滤掉召唤物
        const noPets = this.ourTeam.filter(item => item.star !== "pet");
        // 过滤已经选择了的角色
        result = result.filter(item => !noPets.some(role => role.id === item.id));
      }
      if (this.activeStar) {
        result = result.filter(item => item.star === this.activeStar);
      }
      if (this.activeProperty) {
        result = result.filter(item => item.attr === this.activeProperty);
      }
      if (this.keyword) {
        result = result.filter(item => item.name.includes(this.keyword));
      }
      // 根据星级排序
      result.sort((a, b) => {
        return Number(b.star) - Number(a.star);
      });
      return result;
    }
  },
  mounted() {
    // this.getRoleList();
  },
  methods: {
    getItemBg(data) {
      if (data.attr === "火") {
        return "red";
      } else if (data.attr === "光") {
        return "yellow";
      } else if (data.attr === "水") {
        return "blue";
      } else if (data.attr === "暗") {
        return "purple";
      } else if (data.attr === "风") {
        return "green";
      }
      return "";
    },
    getRoleList() {
      apiGetBattleRoleList().then(res => {
        if (res.code === 0) {
          if (res.data && (res.data.role || res.data.pet)) {
            const result = [];
            res.data.role &&
              res.data.role.forEach(item => {
                if (item.children) {
                  item.children.forEach(child => {
                    result.push({
                      ...child,
                      type: "role"
                    });
                  });
                }
              });
            this.roleList = result;
          }
        }
      });
    },
    handleItem(item) {
      if (this.activeStar === item.val) {
        this.activeStar = "";
        return;
      }
      this.activeStar = item.val;
    },
    handlePropertyItem(item) {
      if (this.activeProperty === item.val) {
        this.activeProperty = "";
        return;
      }
      this.activeProperty = item.val;
    },
    handlePickRole(role) {
      this.visible = false;
      this.$emit("pickRole", role);
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .role-picker-dialog {
  background-color: transparent;
  box-shadow: unset;
  background-image: linear-gradient(155deg, #262f3a 0%, #31415e 100%);
  .el-dialog__title,
  .el-dialog__close {
    color: #fff;
  }
}
.role-picker {
  display: flex;
  flex-direction: column;
  height: 70vh;
  box-sizing: border-box;
  overflow: hidden;
  .filter-bar {
    display: flex;
    height: 40px;
    margin-bottom: 16px;
    column-gap: 12px;
  }
  .search {
    flex-grow: 1;
    padding: 10px 0;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    input {
      width: 100%;
      border: none;
      outline: none;
      color: #fff;
      background: none;
      &::placeholder {
        color: #545766;
      }
    }
  }
  .content {
    flex: 1;
    overflow: auto;
    .role-box {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      .role-item {
        position: relative;
        width: 83px;
        height: 107px;
        border-radius: 8px;
        overflow: hidden;
        // background-color: rgba(210, 202, 197, 0.46);
        cursor: pointer;
        .bottom-info {
          position: absolute;
          display: flex;
          justify-content: center;
          align-items: center;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 24px;
          color: #fff;
          font-size: 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          // background-color: #665f5d;
          border-radius: 0 0 8px 8px;
          background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
  .footer {
    width: fit-content;
    display: flex;
    .tab-box {
      display: flex;
      align-items: center;
      height: 100%;
      padding: 4px;
      margin-right: 12px;
      border-radius: 4px;
      background: rgba(0, 0, 0, 0.3);
      box-sizing: border-box;
      .tab-item {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        padding: 0 14px;
        cursor: pointer;
        color: #545766;
        font-size: 14px;
        border-radius: 4px;
        &.property {
          width: 32px;
          height: 32px;
          margin-right: 10px;
          padding: 0;
          &:last-child {
            margin-right: 0;
          }
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        &.level {
          font-size: 14px;
        }
        &.active {
          background: #3b4655;
          color: #fff;
        }
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
